import { createContext } from "react";

export const SearchInputFilterContext = createContext();
